import * as React from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import {use2FAEnabled} from '@product-web/shared--auth--otp/api'

import {bffHooks} from './bff-hooks'

export const bff = bffHooks

export const useTrustedBeneficiaryConsent = () => {
    const twoFactorEnabledResponse = use2FAEnabled()
    const is2FAEnabled = Boolean(twoFactorEnabledResponse?.data?.enabled)
    const {data, isLoading} = bff.adminConsent.hasTrustedBeneficiariesConsent.useQuery()
    const notApproved = data && !data.approved
    const navigate = useNavigate()
    const location = useLocation()
    const locationState = (location.state ?? {}) as {fromTrustedBeneficiaries?: boolean}

    React.useEffect(() => {
        if (notApproved && !isLoading && is2FAEnabled && !locationState?.fromTrustedBeneficiaries) {
            navigate('/trusted-beneficiaries', {
                state: {redirect: '/'},
            })
        }
    }, [
        is2FAEnabled,
        data,
        locationState?.fromTrustedBeneficiaries,
        notApproved,
        navigate,
        isLoading,
    ])
}
